import { parseApiError } from "utils/parseApiError";
import { TOO_MANY_PLANS_ERROR_CODE } from "../../constants";
import type { ToFolderSuggestionError } from "./types";

export const toFolderSuggestionError: ToFolderSuggestionError = ({ error }) => {
  if (error === null) return null;
  return parseApiError({ error }).errorCode === TOO_MANY_PLANS_ERROR_CODE
    ? "tooManyPlans"
    : "unavailable";
};
